import { Table } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailRegistryRow } from "./SystemEmailRegistryRow";

interface Props {
  entries: SystemEmailRegistryEntry[];
  onPreview: (id: string) => void;
}

export function SystemEmailRegistryBody({ entries, onPreview }: Props) {
  return (
    <Table.Tbody>
      {entries.map((entry) => (
        <SystemEmailRegistryRow
          entry={entry}
          key={entry.id}
          onPreview={onPreview}
        />
      ))}
    </Table.Tbody>
  );
}
